module.exports = __webpack_public_path__ + "static/media/Ella.bd1087b2.jpg";